let devUrl, hostUrl
// let address = window.location.href;
// if (
//   address.indexOf("dev.zking.com") !== -1 ||
//   address.indexOf("localhost") !== -1||
//   address.indexOf("http://127.0.0.1/") !== -1
// ) {
//   console.log('dev:',address)
//   devUrl = 'https://test-open.zking.com'
//   hostUrl = 'https://test-open.zking.com'
//   console.log('devUrl:',devUrl)
// } else if (address.indexOf("uat.zking.com") !== -1) {
//   console.log('uat:',address)
//   devUrl = 'https://uat-open.zking.com'
//   hostUrl = 'https://uat-open.zking.com'
//   console.log('devUrl:',devUrl)
// } else if (address.indexOf("prod.zking.com") !== -1) {
//   console.log('prod:',address)
//   devUrl = 'https://open.zking.com'
//   hostUrl = 'https://open.zking.com'
//   console.log('devUrl:',devUrl)
// }
if (process.env.ENV_CONFIG == 'dev' ) {
  devUrl = process.env.API_HOST
  console.log(devUrl)
  hostUrl = 'https://test-open.zking.com'
} else if (process.env.ENV_CONFIG == 'uat') {
  devUrl = process.env.API_HOST
  hostUrl = 'https://uat-open.zking.com'
} else if (process.env.ENV_CONFIG == 'prod') {
  devUrl = process.env.API_HOST
  hostUrl = 'https://open.zking.com'
}
let imgUrl = 'https://open.zking.com/r/cms/internet-static/zking-insurance-sales'
module.exports = {
  hostUrl,
  check: devUrl + 'gateway/commontools/captcha/check', // 验证码校验
  imgAllUrl: imgUrl + '/images',
  imgallurls: devUrl + '/activitys/',
  carActivity: devUrl + '/activity/',
  //保费概况
  queryPolicyFee:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryPolicyFee',
  queryClaimPay:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryClaimPay',
  queryRiskFee:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryRiskFee',
  queryComCodeFee:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryComCodeFee',
  queryBasicInfo:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryBasicInfo',
  queryRiskPay:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryRiskPay',
  queryComCodePay:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryComCodePay',
  queryPaymentInfo:devUrl+'/temp/api/v1/insurance/agriculture/agristatistic/queryPaymentInfo',
  printProposalH5:devUrl+'/api/v1/insurance/public/proposal/printProposalH5',
  saveHouseholdReadlnfo:devUrl+'/api/v1/insurance/public/ciagrinsurepublicityresponse/saveHouseholdReadInfo',
  getReadrecordByProposalno:devUrl+'/api/v1/insurance/public/ciagrinsurepublicityresponse/getReadrecordByProposalno',
  proposalProvisionsH5List:devUrl+'/api/v1/insurance/public/proposal/proposalProvisionsH5List',
  saveIssueCode:devUrl+'/api/v1/insurance/public/business/saveIssueCode',
  hubeiQueryRiskInfo:devUrl+'/api/v1/agriculture/agrielec-platform/hubei/hubeiQueryRiskInfo',
  hubeiQueryRiskPDF:devUrl+'/api/v1/agriculture/agrielec-platform/hubei/hubeiQueryRiskPDF',
  faceUrl:devUrl+'/api/v1/claim-agriculture/claimadjustment/quickClaim/faceIdentify',
  queryVerifyInfo:devUrl+'/api/v1/claim-agriculture/claimadjustment/quickClaim/queryVerifyInfo',
  faceIdentifyResult:devUrl+'/api/v1/claim-agriculture/claimadjustment/quickClaim/faceIdentifyResult',
  upload:devUrl+'/temp/api/v1/insurance/public/file/upload',
  verifyconfirm:devUrl+'/api/v1/claim-agriculture/claimadjustment/quickClaim/verifyconfirm',

}



// WEBPACK FOOTER //
// ./src/api/api.js